// extracted by mini-css-extract-plugin
module.exports = {"link":"styles-module--link--dbwiq","twitterLogo":"styles-module--twitterLogo--bMoto","cta":"styles-module--cta--2fuK9","content":"styles-module--content--2mW6a"};